"use client";

import { emailOTPClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

const apiBaseURL = process.env.NEXT_PUBLIC_NEWFORM_API_DOMAIN;
if (process.env.NODE_ENV === "production" && !apiBaseURL)
  throw new Error(
    "NEXT_PUBLIC_NEWFORM_API_DOMAIN is required for creator sign-in",
  );

// Auth cookies belong to the API host. The existing Stytch session is separate.
export const sharedAuthClient = createAuthClient({
  baseURL: apiBaseURL ?? "http://localhost:3001",
  basePath: "/api/auth",
  fetchOptions: { credentials: "include" },
  plugins: [emailOTPClient()],
});
